import { createStore } from 'vuex'

export default createStore({
    state: {
        aid: '64d44d17aadffd00358df7eb', // 活动id
        musicPaused: false,// 音乐播放状态
        userInfo: {}, // 用户信息
        dialogData: null, // 弹框数据
        activityData: null, // 活动数据
        shareData: {}, // 分享信息
        topicData: {}
    },
    mutations: {
        SET_AID (state, aid: string) {
            state.aid = aid
        },
        SET_MUSICPAUSED (state, flag: boolean) {
            state.musicPaused = flag
        },
        SET_USERINFO (state, data) {
            state.userInfo = data
        },
        SET_DIALOGDATA (state, data) {
            state.dialogData = data
        },
        SET_SHAREDATA (state, data) {
            state.shareData = data
        },
        SET_ACTIVITYDATA (state, data) {
            state.activityData = data
        },
        SET_TOPICDATA (state, data) {
            state.topicData = data
        },
    },
    actions: {
    },
    modules: {
    }
})
